export function setCookie(cookieName: string, cookieValue: string, expiresDays: number = null, domain?: string): void {
  const date: Date = new Date();
  date.setTime(date.getTime() + expiresDays * 24 * 60 * 60 * 1000);

  // The domain must match the domain of the JavaScript origin. Setting cookies to foreign domains will be silently ignored.
  const expires: string = ';expires=' + date.toUTCString();
  window.document.cookie = `${cookieName}=${cookieValue};path=/${expires};${domain ? `domain=${domain}` : ``}`;
}

export function getCookie(cookieName: string): string {
  const name: string = cookieName + '=';
  const cookies = document.cookie.split(';');

  for (let cookie of cookies) {
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
    if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length);
  }
  return null;
}

export function expireCookie(cookieName: string) {
  window.document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;`;
}
